import * as React from 'react';
import { UIHeading1, UIText1 } from '@cian/ui-kit';
import styles from './Factoid.css';
import { nbspJsString } from '../../../../../constants/symbols';

type TitleElement = {
  id: number;
  text: string;
  isText?: boolean;
};

type FactoidProps = {
  title: TitleElement[];
  subtitle: string;
};

export const Factoid: React.FC<FactoidProps> = props => {
  const { subtitle, title } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        {title.reduce((accumulator, titleElement, index, arr) => {
          if (titleElement.isText) {
            accumulator.push(
              <div key={titleElement.id} className={styles['title-text-element']}>
                <UIText1 fontWeight="bold" color="current_color">
                  {titleElement.text}
                </UIText1>
              </div>,
            );
          } else {
            accumulator.push(
              <UIHeading1 key={titleElement.id} color="current_color">
                {titleElement.text}
              </UIHeading1>,
            );
          }

          if (arr.length - 1 !== index) {
            accumulator.push(nbspJsString);
          }

          return accumulator;
        }, Array.of<React.JSX.Element | string>())}
      </div>
      <UIText1 color="current_color">{subtitle}</UIText1>
    </div>
  );
};
